import customFetchBase from "../../../principal/customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";

export const examenApi = createApi({
  reducerPath: "examenApi",
  baseQuery: customFetchBase,
  tagTypes: ["Examenes"],
  endpoints: () => ({}),
});
